import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar'
import Link from '@material-ui/core/Link'
import Toolbar from '@material-ui/core/Toolbar'
import Logo from 'assets/images/dokify-logo-black.svg'
import useStyles from './styles'
import Container from '@material-ui/core/Container'

const LandingHeader = () => {
  const classes = useStyles()

  return (
    <AppBar
      position="absolute"
      color="transparent"
      elevation={1}
      className={classes.root}
    >
      <Container>
        <Toolbar className={classes.header} disableGutters={false}>
          <Link className={classes.headerTitle} component={RouterLink} to="/">
            <img src={Logo} alt="Dokify" />
          </Link>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default LandingHeader
